// extracted by mini-css-extract-plugin
export var spacer = "spacer-module--spacer--useJD";